import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, FontAwesomeModule, NgOptimizedImage],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  
  isLoading = false;
  hasErrorLogin = false;
  faSpinner = faSpinner;
  
  loginForm: FormGroup = this.formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', Validators.required]
  });

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService
  ) { }

  onLogin() {
    if (this.loginForm.valid) {
      this.isLoading = true;
      this.authService.login({ ...this.loginForm.value }).subscribe((res: any) => {
        localStorage.setItem('user', JSON.stringify(res));
        this.router.navigate(['/']);
        this.isLoading = false;
      }, () => {
        this.isLoading = false;
        this.hasErrorLogin = true;
      });
    }
  }

  closeNotification() {
    this.hasErrorLogin = false;
  }


}
